import { RouteComponentProps } from 'react-router-dom';
import { parse } from '@tock/query-string';

import { IWithContextProps, withContext } from '@tock/coretypes';
import BaseComponent from '@tock/shared/components/BaseComponent';
import connect, { DefaultConnectProps } from '@tock/shared/utils/connect';

class EmailChangeCancelRoute extends BaseComponent<
  DefaultConnectProps & RouteComponentProps & IWithContextProps
> {
  componentDidMount() {
    const {
      actions,
      history,
      location: { search },
    } = this.props;
    const query = parse(search);

    if (!query.token) {
      actions.toast.showError('Your email change confirmation link is invalid.');
      history.push('/');
    }

    actions.app.cancelEmailChange(query.token).then(this.handleSuccess).catch(this.handleFailure);
  }

  handleFailure() {
    this.props.actions.toast.showError('Something went wrong.');
    this.props.history.push(`/profile/account`);
  }

  handleSuccess() {
    this.props.history.push(`/profile/account`);
  }

  render() {
    return null;
  }
}

export default connect<RouteComponentProps>(withContext(EmailChangeCancelRoute));
